const BASE_BODY = {
  operator: "globojogal",
  mode: "fun",
  channel: "desktop",
  jurisdiction: "99",
  token: "b",
  ip: "",
  user: "",
  disallowPromos: false,
};

async function tryPostLaunch(
  gameId: string,
  lang: string,
  currency: string
): Promise<string> {
  const response = await fetch(
    "https://sales.globalgames.io/slot-server/api/globojogal/get_launcher_url",
    {
      method: "POST",
      headers: { Token: "b", "Content-Type": "application/json" },
      body: JSON.stringify({
        ...BASE_BODY,
        game: gameId,
        lang,
        currency,
        lobby: window.location.origin + "/",
        cashier: window.location.origin + "/",
      }),
    }
  );

  if (!response.ok) throw new Error(`${response.status}`);

  const data = await response.json();
  if (data.error !== 0)
    throw new Error(data.description || `error ${data.error}`);
  const url = data.result?.url || data.result?.launchUrl || data.url;
  if (!url) throw new Error("No URL in response");
  return url;
}

const OW_DEV_IDS: string[] = [
  "BLINDFOLLOWINGTHEBLIND95",
  "SURVIVORWHEEL98",
];
const OW_QA_IDS: string[] = ["BALANCEBEAMCRASH4S7"];


export function getOWCasinoId(gameId: string) {
  if (OW_DEV_IDS.includes(gameId)) return 1;
  if (OW_QA_IDS.includes(gameId)) return 2;
}

const getOWLauncherUrl = (
  gameId: string,
  siteId: string,
  tokenId: string,
  userId: string,
  gameURL: string
) =>
  `https://launcher-shy-frost-6936.fly.dev/resolve?gameId=${gameId}&userId=${userId}&token=${tokenId}&siteId=${siteId}&gameURL=${gameURL}`;

const getRandomToken = () => {
  return (
    Math.random().toString(36).substring(3, 15).toUpperCase() +
    "-" +
    Math.random().toString(36).substring(3, 11).toUpperCase() +
    "-" +
    Math.random().toString(36).substring(3, 6).toUpperCase()
  );
};
const getRandomURL = () => {
  return "TEST_USER_" + Math.random().toString().substring(3, 8).toUpperCase();
};

async function getOddsworkUrl(gameId: string, gameUrl: string) {
  const randomToken = getRandomToken();
  const randomUser = getRandomURL();
  const siteId = OW_DEV_IDS.includes(gameId)
    ? "oddsworks-dev"
    : OW_QA_IDS.includes(gameId)
    ? "oddsworks-dev"
    : null;
  console.log("Opening", { siteId, gameId, randomToken, randomUser, gameUrl });
  if (!siteId) throw new Error("No env to launch");
  const launcherUrl = getOWLauncherUrl(
    gameId,
    siteId,
    randomToken,
    randomUser,
    gameUrl
  );
  const { gameUrl: url } = await fetch(launcherUrl, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  }).then((res) => res.json());
  console.log("Launcher URL", url);
  if (!url) throw new Error("No URL in response");
  return url;
}

function getStaticUrl(gameId: string): string {
  return `https://sales.globalgames.io/rgs/games/v2/launch?gameId=${gameId}&lang=en&currency=EUR&gameMode=DEMO&operatorId=globojogal`;
}

export async function getLauncherUrl(
  gameId: string,
  launchProvider?: string,
  gameUrl?: string
): Promise<string> {
  // console.log('should open ', gameId, gameUrl);
  if (launchProvider === "oddswork") {
    if (!gameUrl) throw new Error("gameUrl is required for oddswork launcher");
    return getOddsworkUrl(gameId, gameUrl);
  }
  try {
    return await tryPostLaunch(gameId, "en-us", "USD");
  } catch {
    try {
      return await tryPostLaunch(gameId, "pt-BR", "BRL");
    } catch {
      return getStaticUrl(gameId);
    }
  }
}
